jQuery($ => {
    class RemoveFromQuoteButton {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._ajaxRunning = false;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      handleClick() {
        if (this._ajaxRunning) {
          return;
        }
  
        const productId = this._element.data('product-id');
        const nonce = this._element.data('nonce');
        const form = this._element.closest('form');
  
        if (!productId || !nonce) {
          return;
        }        
  
        $.ajax({
          type: 'POST',
          url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'remove_from_cart' ),
          data: {
            'action': 'remove_from_cart',
            'cart_item_key': productId,
            'nonce': nonce,
          },
          beforeSend: () => {
            this._ajaxRunning = true;
            this._element.attr('disabled', 'disabled');
            
            if (form.length) {
              form.addClass('loading');
            }
          },
          success: (result) => {
            console.log(result);
            if (result?.fragments) {
              // Add ?removed_item=1 to the URL and reload page
              const url = new URL(window.location.href);
              url.searchParams.set('removed_item', '1');

              // Reload page
              window.location.href = url.toString();
            } else {
              if (form.length) {
                form.removeClass('loading');
              }
            }
          },
          error: function(error) {
            console.error(error);
            if (form.length) {
              form.removeClass('loading');
            }
          },
          complete: () => {
            this._ajaxRunning = false;
            this._element.removeAttr('disabled');            
          }
        })
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on('click', () => this.handleClick());
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.remove_from_quote_button = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].remove_from_quote_button = new RemoveFromQuoteButton(_[i], opt);
        else
          ret = _[i].remove_from_quote_button[opt].apply(_[i].remove_from_quote_button, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-remove-from-quote-button').remove_from_quote_button();
});